import { render, staticRenderFns } from "./TaskCreationPage.vue?vue&type=template&id=55a42610&"
import script from "./TaskCreationPage.vue?vue&type=script&lang=ts&"
export * from "./TaskCreationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports